// /**
//  * PDPCatalog.tsx — Shopify BOPIS product page behaviors.
//  */
// (function () {
//   'use strict';

//   var root = document.getElementById('ez-pdp-catalog');
//   if (!root) return;

//   document.body.classList.add('ez-pdp-catalog-sticky-active');

//   var initialStore = root.dataset.initialStoreName;
//   var baseSavedCount = parseInt(root.dataset.savedCount || '0', 10) || 0;

//   var modal = document.getElementById('ez-pdp-interest-modal');
//   var interestButtons = root.querySelectorAll('[data-ez-pdp-interest-open]');
//   /* Online exclusive add-to-cart — temporarily disabled.
//   var variantSelect = root.querySelector('[data-ez-pdp-variant-select]');
//   var addToCartButtons = root.querySelectorAll('[data-ez-pdp-add-to-cart]');
//   */
//   var closeBtn = modal && modal.querySelector('[data-ez-pdp-interest-close]');
//   var cancelBtn = modal && modal.querySelector('[data-ez-pdp-interest-cancel]');
//   var wishlistButtons = root.querySelectorAll('[data-ez-pdp-wishlist]');
//   var storeLabel = root.querySelector('[data-ez-pdp-store-label]');
//   var saveCountEls = root.querySelectorAll('[data-ez-pdp-save-count]');
//   var savedBadge = root.querySelector('[data-ez-pdp-saved-badge]');
//   var form = document.getElementById('ez-pdp-interest-form');
//   var bodyField = form && form.querySelector('[data-ez-pdp-interest-body]');
//   var contactNameField = form && form.querySelector('[data-ez-pdp-contact-name]');
//   var firstNameInput = form && form.querySelector('[data-ez-pdp-first-name]');
//   var lastNameInput = form && form.querySelector('[data-ez-pdp-last-name]');
//   var mobileInput = form && form.querySelector('[data-ez-pdp-mobile]');
//   var consentInput = form && form.querySelector('[data-ez-pdp-consent]');
//   var submitBtn = form && form.querySelector('[data-ez-pdp-interest-submit]');
//   var modalContactPhone = modal && modal.querySelector('[data-ez-pdp-modal-contact-phone]');
//   var modalContactPhoneText = modal && modal.querySelector('[data-ez-pdp-modal-contact-phone-text]');
//   var modalContactAddress = modal && modal.querySelector('[data-ez-pdp-modal-contact-address]');
//   var modalContactAddressText = modal && modal.querySelector('[data-ez-pdp-modal-contact-address-text]');
//   var modalContactNote = modal && modal.querySelector('[data-ez-pdp-modal-contact-note]');

//   var galleryTrack = root.querySelector('[data-ez-pdp-gallery-track]');
//   var galleryCounter = root.querySelector('[data-ez-pdp-gallery-counter]');
//   var galleryDots = root.querySelector('[data-ez-pdp-gallery-dots]');
//   var thumbButtons = root.querySelectorAll('[data-ez-pdp-thumb]');

//   var storeNameEl = root.querySelector('[data-ez-pdp-store-name]');
//   var storeAddressEl = root.querySelector('[data-ez-pdp-store-address]');
//   var storePhoneEl = root.querySelector('[data-ez-pdp-store-phone]');
//   var storeDirectionsEl = root.querySelector('[data-ez-pdp-store-directions]');
//   var storeHoursEl = root.querySelector('[data-ez-pdp-store-hours]');

//   function getSwymButton() {
//     return document.querySelector(
//       '.swym-add-to-wishlist-view-product.product_' + root.dataset.productId
//     );
//   }

//   function getDisplaySavedCount(userSaved) {
//     return baseSavedCount + (userSaved ? 1 : 0);
//   }

//   function updateSaveCounts(userSaved) {
//     var count = getDisplaySavedCount(userSaved);
//     var show = count >= 1;
//     saveCountEls.forEach(function (el) {
//       if (show) {
//         el.textContent = String(count);
//         el.hidden = false;
//       } else {
//         el.hidden = true;
//       }
//     });
//     if (savedBadge && count > 0) {
//       savedBadge.textContent = 'Saved by ' + count + ' people';
//       savedBadge.hidden = false;
//     }
//   }

//   function syncWishlistPressed() {
//     var swym = getSwymButton();
//     var saved = swym && (swym.classList.contains('swym-added') || swym.getAttribute('aria-pressed') === 'true');
//     wishlistButtons.forEach(function (btn) {
//       btn.classList.toggle('is-saved', !!saved);
//       btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
//       btn.setAttribute('aria-label', saved ? 'Remove from Wishlist' : 'Save to Wishlist');
//     });
//     updateSaveCounts(!!saved);
//   }

//   function updateModalContactCard() {
//     var store = (window.storesData || {})[window.currentStoreTag];
//     if (!store) return;
//     var name = store.brand || store.name || 'Store';

//     if (modalContactPhone && modalContactPhoneText && store.phone) {
//       modalContactPhoneText.textContent = store.phone;
//       modalContactPhone.href = 'tel:' + store.phone.replace(/\D/g, '');
//       modalContactPhone.hidden = false;
//     }

//     if (modalContactAddress && modalContactAddressText && store.address) {
//       modalContactAddressText.textContent = store.address;
//       modalContactAddress.hidden = false;
//     }

//     if (modalContactNote) {
//       modalContactNote.textContent =
//         'Call ' + name + ', mention this item, and a team member will hold it for you.';
//     }
//   }

//   function updateStoreLabels() {
//     var store = (window.storesData || {})[window.currentStoreTag];
//     if (!store) return;
//     var name = store.brand || store.name || 'Store';
//     var text = name + ' · text or call back';
//     if (storeLabel) storeLabel.textContent = text;
//     if (storeNameEl) storeNameEl.textContent = name;
//     if (storeAddressEl) storeAddressEl.textContent = store.address || '';
//     if (storeHoursEl) {
//       var today = new Date().toLocaleDateString('en-US', { weekday: 'long' });
//       var hoursToday = store.hours && store.hours[today] ? store.hours[today] : 'See store hours';
//       if (hoursToday === 'Closed' || hoursToday === 'Closed today') {
//         storeHoursEl.textContent = '● Closed today';
//       } else {
//         var closingParts = hoursToday.split(/[–-]/);
//         var closingTime =
//           closingParts.length > 1 ? closingParts[closingParts.length - 1].trim() : hoursToday;
//         storeHoursEl.textContent = '● Open until ' + closingTime;
//       }
//     }
//     if (storePhoneEl && store.phone) {
//       storePhoneEl.textContent = store.phone;
//       storePhoneEl.hidden = false;
//     }
//     if (storeDirectionsEl && store.address) {
//       storeDirectionsEl.href =
//         'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(store.address);
//       storeDirectionsEl.hidden = false;
//     }

//     updateModalContactCard();
//   }

//   function initDescriptionTabs() {
//     var tabs = root.querySelectorAll('[data-ez-pdp-desc-tab]');
//     var panels = root.querySelectorAll('[data-ez-pdp-desc-panel]');
//     if (!tabs.length || !panels.length) return;

//     tabs.forEach(function (tab) {
//       tab.addEventListener('click', function () {
//         var target = tab.getAttribute('data-ez-pdp-desc-tab');

//         tabs.forEach(function (item) {
//           var isActive = item === tab;
//           item.classList.toggle('is-active', isActive);
//           item.setAttribute('aria-selected', isActive ? 'true' : 'false');
//         });

//         panels.forEach(function (panel) {
//           var isActive = panel.getAttribute('data-ez-pdp-desc-panel') === target;
//           panel.classList.toggle('is-active', isActive);
//           if (isActive) {
//             panel.removeAttribute('hidden');
//           } else {
//             panel.setAttribute('hidden', '');
//           }
//         });
//       });
//     });
//   }

//   function openModal() {
//     if (!modal) return;
//     updateModalContactCard();
//     modal.classList.add('is-open');
//     modal.setAttribute('aria-hidden', 'false');
//     document.body.style.overflow = 'hidden';
//     if (firstNameInput) firstNameInput.focus();
//   }

//   function closeModal() {
//     if (!modal) return;
//     modal.classList.remove('is-open');
//     modal.setAttribute('aria-hidden', 'true');
//     document.body.style.overflow = '';
//   }

//   function getExponea() {
//     return window.exponea;
//   }

//   function formatPhoneE164(digits) {
//     if (!digits) return '';
//     if (digits.length === 10) return '+1' + digits;
//     if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
//     return '+' + digits;
//   }

//   function getInterestFormValues() {
//     var emailInput = form && form.querySelector('#ez-pdp-email');
//     var firstName = firstNameInput ? firstNameInput.value.trim() : '';
//     var lastName = lastNameInput ? lastNameInput.value.trim() : '';
//     var email = emailInput ? emailInput.value.trim() : '';
//     var phoneDigits = mobileInput ? mobileInput.value.replace(/\D/g, '') : '';
//     var consentLabel = consentInput && consentInput.closest('label');
//     var consentMessage = '';
//     if (consentLabel) {
//       var messageEl = consentLabel.querySelector('span');
//       consentMessage = messageEl ? messageEl.textContent.trim() : '';
//     }
//     return {
//       firstName: firstName,
//       lastName: lastName,
//       email: email,
//       phone: mobileInput ? mobileInput.value.trim() : '',
//       phoneE164: formatPhoneE164(phoneDigits),
//       marketingConsent: !!(consentInput && consentInput.checked),
//       consentMessage: consentMessage,
//     };
//   }

//   function trackConsentEvent(exponea, action, category, values) {
//     var props = {
//       action: action,
//       category: category,
//       valid_until: 'unlimited',
//       timestamp: Math.floor(Date.now() / 1000),
//       source: 'store_inquiry_form',
//     };
//     if (values.email) props.email = values.email;
//     if (values.consentMessage) props.message = values.consentMessage;
//     exponea.track('consent', props);
//   }

//   function trackInterestExponea() {
//     var exponea = getExponea();
//     if (!exponea || typeof exponea.track !== 'function') return;

//     var values = getInterestFormValues();
//     var displayedStore = getDisplayedStoreInfo() || {};

//     if (values.email && typeof exponea.identify === 'function') {
//       exponea.identify({ email_id: values.email });
//     }

//     if (typeof exponea.update === 'function') {
//       var updatePayload = {
//         first_name: values.firstName,
//         last_name: values.lastName,
//       };
//       if (values.email) updatePayload.email = values.email;
//       if (values.phoneE164) updatePayload.phone = values.phoneE164;
//       exponea.update(updatePayload);
//     }

//     exponea.track('store_inquiry', {
//       product_id: root.dataset.productId || '',
//       product_title: root.dataset.productTitle || '',
//       product_handle: root.dataset.productHandle || '',
//       variant_id: root.dataset.variantId || '',
//       product_url: window.location.href,
//       first_name: values.firstName,
//       last_name: values.lastName,
//       email: values.email,
//       phone: values.phone,
//       marketing_consent: values.marketingConsent,
//       store_name: displayedStore.store_name || '',
//       store_phone: displayedStore.store_phone || '',
//       store_address: displayedStore.store_address || '',
//       store_hours: displayedStore.store_hours || '',
//       store_distance: displayedStore.store_distance || '',
//     });

//     if (values.marketingConsent) {
//       trackConsentEvent(exponea, 'accept', 'marketing', values);
//       trackConsentEvent(exponea, 'accept', 'sms', values);
//     } else {
//       trackConsentEvent(exponea, 'reject', 'marketing', values);
//       trackConsentEvent(exponea, 'reject', 'sms', values);
//     }
//   }

//   function validateForm() {
//     if (!submitBtn || !firstNameInput || !lastNameInput || !mobileInput) return;
//     var firstOk = firstNameInput.value.trim().length > 0;
//     var lastOk = lastNameInput.value.trim().length > 0;
//     var digits = mobileInput.value.replace(/\D/g, '');
//     submitBtn.disabled = !(firstOk && lastOk && digits.length >= 10);
//   }

//   function getDisplayedStoreInfo() {
//     var card = root.querySelector('[data-ez-pdp-store-card]');
//     if (!card) return null;

//     function text(el) {
//       return el && !el.hidden ? el.textContent.trim() : '';
//     }

//     var info = {
//       store_name: (card.querySelector('[data-ez-pdp-store-name]') || {}).textContent || '',
//       store_address: (card.querySelector('[data-ez-pdp-store-address]') || {}).textContent || '',
//       store_phone: text(card.querySelector('[data-ez-pdp-store-phone]')),
//       store_hours: (card.querySelector('[data-ez-pdp-store-hours]') || {}).textContent || '',
//       store_distance: text(card.querySelector('[data-ez-pdp-store-distance]')),
//     };
//     info.store_name = info.store_name.trim();
//     info.store_address = info.store_address.trim();
//     info.store_hours = info.store_hours.trim();

//     if (!info.store_name && !info.store_address && !info.store_phone) return null;
//     return info;
//   }

//   function buildContactBody() {
//     var firstName = firstNameInput ? firstNameInput.value.trim() : '';
//     var lastName = lastNameInput ? lastNameInput.value.trim() : '';
//     var lines = [
//       'Product interest request',
//       'Product: ' + (root.dataset.productTitle || ''),
//       'URL: ' + window.location.href,
//       'Variant ID: ' + (root.dataset.variantId || ''),
//       'First name: ' + firstName,
//       'Last name: ' + lastName,
//     ];
//     if (form) {
//       var email = form.querySelector('#ez-pdp-email');
//       if (email && email.value.trim()) lines.push('Email: ' + email.value.trim());
//     }
//     if (consentInput) {
//       lines.push('Marketing consent: ' + (consentInput.checked ? 'Yes' : 'No'));
//     }
//     var displayedStore = getDisplayedStoreInfo();
//     if (displayedStore) {
//       if (displayedStore.store_name) lines.push('Store: ' + displayedStore.store_name);
//       if (displayedStore.store_phone) lines.push('Store phone: ' + displayedStore.store_phone);
//       if (displayedStore.store_address) lines.push('Store address: ' + displayedStore.store_address);
//       if (displayedStore.store_hours) lines.push('Store hours: ' + displayedStore.store_hours);
//       if (displayedStore.store_distance) lines.push('Store distance: ' + displayedStore.store_distance);
//     }
//     return lines.join('\n');
//   }

//   function syncContactNameField() {
//     if (!contactNameField || !firstNameInput || !lastNameInput) return;
//     var fullName = [firstNameInput.value.trim(), lastNameInput.value.trim()]
//       .filter(Boolean)
//       .join(' ');
//     contactNameField.value = fullName;
//   }

//   function bodyOverflows(body) {
//     if (!body) return false;
//     var wasExpanded = body.classList.contains('is-expanded');
//     body.classList.remove('is-expanded');
//     var overflows = body.scrollHeight > body.clientHeight + 1;
//     if (wasExpanded) body.classList.add('is-expanded');
//     return overflows;
//   }

//   function updateReadMoreVisibility(wrap) {
//     var body = wrap.querySelector('[data-ez-pdp-read-more-body]');
//     var btn = wrap.querySelector('[data-ez-pdp-read-more]');
//     if (!body || !btn) return;

//     var expanded = btn.getAttribute('aria-expanded') === 'true';
//     if (expanded) {
//       btn.hidden = false;
//       return;
//     }

//     btn.hidden = !bodyOverflows(body);
//   }

//   function initReadMoreLinks() {
//     var wraps = root.querySelectorAll('[data-ez-pdp-read-more-wrap]');

//     function refreshAll() {
//       wraps.forEach(updateReadMoreVisibility);
//     }

//     wraps.forEach(function (wrap) {
//       var body = wrap.querySelector('[data-ez-pdp-read-more-body]');
//       var btn = wrap.querySelector('[data-ez-pdp-read-more]');
//       if (!body || !btn) return;

//       btn.addEventListener('click', function () {
//         var expanded = btn.getAttribute('aria-expanded') === 'true';
//         var nextExpanded = !expanded;

//         btn.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
//         body.classList.toggle('is-expanded', nextExpanded);
//         btn.textContent = nextExpanded ? 'Read less' : 'Read more';
//         btn.hidden = false;
//       });
//     });

//     refreshAll();

//     var resizeTimer;
//     window.addEventListener('resize', function () {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(refreshAll, 150);
//     });
//   }

//   function initGallery() {
//     if (!galleryTrack) return;
//     var slides = galleryTrack.querySelectorAll('[data-ez-pdp-gallery-slide]');
//     var total = slides.length;
//     if (total <= 1) return;

//     if (galleryDots) {
//       galleryDots.innerHTML = '';
//       for (var d = 0; d < total; d++) {
//         var dot = document.createElement('span');
//         dot.className = 'ez-pdp-catalog__gallery-dot' + (d === 0 ? ' is-active' : '');
//         galleryDots.appendChild(dot);
//       }
//     }

//     function setActive(index) {
//       if (galleryCounter) galleryCounter.textContent = index + 1 + ' / ' + total;
//       if (galleryDots) {
//         var dots = galleryDots.querySelectorAll('.ez-pdp-catalog__gallery-dot');
//         dots.forEach(function (dot, i) {
//           dot.classList.toggle('is-active', i === index);
//         });
//       }
//       thumbButtons.forEach(function (btn, i) {
//         btn.classList.toggle('is-active', i === index);
//       });
//     }

//     function scrollToIndex(index) {
//       var w = galleryTrack.offsetWidth;
//       if (!w) return;
//       galleryTrack.scrollTo({ left: index * w, behavior: 'smooth' });
//       setActive(index);
//     }

//     galleryTrack.addEventListener(
//       'scroll',
//       function () {
//         var w = galleryTrack.offsetWidth;
//         if (!w) return;
//         setActive(Math.round(galleryTrack.scrollLeft / w));
//       },
//       { passive: true }
//     );

//     thumbButtons.forEach(function (btn) {
//       btn.addEventListener('click', function () {
//         scrollToIndex(parseInt(btn.getAttribute('data-ez-pdp-thumb') || '0', 10));
//       });
//     });
//   }

//   /* Online exclusive add-to-cart — temporarily disabled.
//   function updateAddToCartAvailability() {
//     if (!variantSelect || !addToCartButtons.length) return;
//     var option = variantSelect.options[variantSelect.selectedIndex];
//     var available = option && !option.disabled;
//     addToCartButtons.forEach(function (btn) {
//       btn.disabled = !available;
//       btn.classList.toggle('ez-pdp-catalog__btn-primary--disabled', !available);
//     });
//     if (root.dataset.variantId && option) {
//       root.dataset.variantId = option.value;
//     }
//   }

//   if (variantSelect) {
//     variantSelect.addEventListener('change', updateAddToCartAvailability);
//     updateAddToCartAvailability();
//   }
//   */

//   interestButtons.forEach(function (btn) {
//     btn.addEventListener('click', openModal);
//   });
//   if (closeBtn) closeBtn.addEventListener('click', closeModal);
//   if (cancelBtn) cancelBtn.addEventListener('click', closeModal);
//   if (modal) {
//     modal.addEventListener('click', function (e) {
//       if (e.target === modal) closeModal();
//     });
//   }

//   document.addEventListener('keydown', function (e) {
//     if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
//   });

//   wishlistButtons.forEach(function (btn) {
//     btn.addEventListener('click', function () {
//       var swym = getSwymButton();
//       if (swym) swym.click();
//       setTimeout(syncWishlistPressed, 400);
//     });
//   });

//   if (form) {
//     form.addEventListener('input', validateForm);
//     form.addEventListener('change', validateForm);
//     form.addEventListener('submit', function (e) {
//       e.preventDefault();
//       syncContactNameField();
//       if (bodyField) bodyField.value = buildContactBody();
//       validateForm();
//       if (submitBtn && submitBtn.disabled) return;

//       trackInterestExponea();

//       submitBtn.disabled = true;
//       submitBtn.textContent = 'Sending...';
//       var formData = new FormData(form);
//       fetch(form.action, {
//         method: 'POST',
//         body: formData,
//         headers: { Accept: 'application/json' },
//       })
//         .then(function () {
//           submitBtn.textContent = 'Sent!';
//           form.reset();
//           setTimeout(function () {
//             closeModal();
//             submitBtn.textContent = 'Share Item Details';
//             submitBtn.disabled = true;
//           }, 1800);
//         })
//         .catch(function () {
//           submitBtn.textContent = 'Share Item Details';
//           submitBtn.disabled = false;
//           alert('Something went wrong. Please try again.');
//         });
//     });
//     validateForm();
//   }

//   if (initialStore) {
//     var text = initialStore + ' · text or call back';
//     if (storeLabel) storeLabel.textContent = text;
//     if (modalContactNote) {
//       modalContactNote.textContent =
//         'Call ' + initialStore + ', mention this item, and a team member will hold it for you.';
//     }
//   }

//   document.addEventListener('storesDataReady', function () {
//     updateStoreLabels();
//   });
//   document.addEventListener('DOMContentLoaded', function () {
//     if (window.storesData) updateStoreLabels();
//   });
//   if (window.storesData) updateStoreLabels();

//   initReadMoreLinks();
//   initGallery();
//   initDescriptionTabs();
//   syncWishlistPressed();

//   var swymObserve = getSwymButton();
//   if (swymObserve && typeof MutationObserver !== 'undefined') {
//     var mo = new MutationObserver(syncWishlistPressed);
//     mo.observe(swymObserve, { attributes: true, attributeFilter: ['class', 'aria-pressed'] });
//   }

//   setInterval(syncWishlistPressed, 2000);
// })();



/**
 * PDPCatalog.tsx — Shopify BOPIS product page behaviors.
 */
(function () {
  'use strict';

  var root = document.getElementById('ez-pdp-catalog');
  if (!root) return;

  document.body.classList.add('ez-pdp-catalog-sticky-active');

  var initialStore = root.dataset.initialStoreName;
  var baseSavedCount = parseInt(root.dataset.savedCount || '0', 10) || 0;

  var modal = document.getElementById('ez-pdp-interest-modal');
  var confirmModal = document.getElementById('ez-pdp-interest-confirm-modal');
  var interestButtons = root.querySelectorAll('[data-ez-pdp-interest-open]');
  /* Online exclusive add-to-cart — temporarily disabled.
  var variantSelect = root.querySelector('[data-ez-pdp-variant-select]');
  var addToCartButtons = root.querySelectorAll('[data-ez-pdp-add-to-cart]');
  */
  var closeBtn = modal && modal.querySelector('[data-ez-pdp-interest-close]');
  var confirmCloseBtn = confirmModal && confirmModal.querySelector('[data-ez-pdp-interest-confirm-close]');
  var confirmDoneBtn = confirmModal && confirmModal.querySelector('[data-ez-pdp-interest-confirm-done]');
  var wishlistButtons = root.querySelectorAll('[data-ez-pdp-wishlist]');
  var storeLabel = root.querySelector('[data-ez-pdp-store-label]');
  var saveCountEls = root.querySelectorAll('[data-ez-pdp-save-count]');
  var savedBadge = root.querySelector('[data-ez-pdp-saved-badge]');
  var form = document.getElementById('ez-pdp-interest-form');
  var bodyField = form && form.querySelector('[data-ez-pdp-interest-body]');
  var contactNameField = form && form.querySelector('[data-ez-pdp-contact-name]');
  var nameInput = form && form.querySelector('[data-ez-pdp-name]');
  var mobileInput = form && form.querySelector('[data-ez-pdp-mobile]');
  var noteInput = form && form.querySelector('[data-ez-pdp-note]');
  var consentCheckbox = form && form.querySelector('[data-ez-pdp-consent]');
  var submitBtn = form && form.querySelector('[data-ez-pdp-interest-submit]');
  var interestStoreNameEls = document.querySelectorAll('[data-ez-pdp-interest-store-name-text]');
  var confirmStoreName = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-store-name]');
  var confirmHoursBadge = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-hours-badge]');
  var confirmPhoneRow = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-phone-row]');
  var confirmContactPhone = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-contact-phone]');
  var confirmContactPhoneText = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-contact-phone-text]');
  var confirmCallBtn = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-call-btn]');
  var confirmContactAddress = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-contact-address]');
  var confirmContactAddressText = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-contact-address-text]');
  var confirmDirections = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-directions]');
  var confirmMap = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-map]');
  var confirmMapIframe = confirmModal && confirmModal.querySelector('[data-ez-pdp-confirm-map-iframe]');

  var galleryTrack = root.querySelector('[data-ez-pdp-gallery-track]');
  var galleryCounter = root.querySelector('[data-ez-pdp-gallery-counter]');
  var galleryDots = root.querySelector('[data-ez-pdp-gallery-dots]');
  var thumbButtons = root.querySelectorAll('[data-ez-pdp-thumb]');

  var storeNameEl = root.querySelector('[data-ez-pdp-store-name]');
  var storeAddressEl = root.querySelector('[data-ez-pdp-store-address]');
  var storePhoneEl = root.querySelector('[data-ez-pdp-store-phone]');
  var storeDirectionsEl = root.querySelector('[data-ez-pdp-store-directions]');
  var storeHoursEl = root.querySelector('[data-ez-pdp-store-hours]');
  var storeMapEl = root.querySelector('[data-ez-pdp-store-map]');
  var storeMapIframe = root.querySelector('[data-ez-pdp-store-map-iframe]');

  function getSwymButton() {
    return document.querySelector(
      '.swym-add-to-wishlist-view-product.product_' + root.dataset.productId
    );
  }

  function getDisplaySavedCount(userSaved) {
    return baseSavedCount + (userSaved ? 1 : 0);
  }

  function updateSaveCounts(userSaved) {
    var count = getDisplaySavedCount(userSaved);
    var show = count >= 1;
    saveCountEls.forEach(function (el) {
      if (show) {
        el.textContent = String(count);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    if (savedBadge && count > 0) {
      savedBadge.textContent = 'Saved by ' + count + ' people';
      savedBadge.hidden = false;
    }
  }

  function syncWishlistPressed() {
    var swym = getSwymButton();
    var saved = swym && (swym.classList.contains('swym-added') || swym.getAttribute('aria-pressed') === 'true');
    wishlistButtons.forEach(function (btn) {
      btn.classList.toggle('is-saved', !!saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', saved ? 'Remove from Wishlist' : 'Save to Wishlist');
    });
    updateSaveCounts(!!saved);
  }

  function getStoreHoursLabel(store) {
    if (!store || !store.hours) return '';
    var today = new Date().toLocaleDateString('en-US', { weekday: 'long' });
    var hoursToday = store.hours[today] ? store.hours[today] : '';
    if (!hoursToday || hoursToday === 'Closed' || hoursToday === 'Closed today') {
      return 'Closed today';
    }
    var closingParts = hoursToday.split(/[–-]/);
    var closingTime = closingParts.length > 1 ? closingParts[closingParts.length - 1].trim() : hoursToday;
    return 'Open until ' + closingTime;
  }

  // stores.js / Shopify store pages only store the street; city/state come from product tags
  // (city_*, state_*) or the store name tail (e.g. "… Laredo TX").
  function titleCaseWords(value) {
    return String(value || '')
      .trim()
      .replace(/\b([a-z])/g, function (_, c) {
        return c.toUpperCase();
      });
  }

  function cityStateFromName(name) {
    var nameTail = (name || '').indexOf(' - ') !== -1 ? (name || '').split(' - ').pop() : name;
    nameTail = String(nameTail || '').trim();
    if (!nameTail) return { city: '', state: '' };

    var commaMatch = nameTail.match(/,\s*([A-Za-z .'-]+),\s*([A-Z]{2})\b/);
    if (commaMatch) {
      return { city: commaMatch[1].trim(), state: commaMatch[2] };
    }

    // Drop street line ("1102 Zaragoza St.") so trailing "Laredo TX" remains.
    var locTail = nameTail.replace(
      /^.*?\b(?:St|Street|Ave|Avenue|Blvd|Rd|Road|Dr|Drive|Hwy|Highway|Ln|Lane|Pkwy|Plaza|Way|Ct|Court|Pike|Fwy|Freeway)\.?\s+/i,
      ''
    );
    var spaceMatch = locTail.match(/^([A-Za-z][A-Za-z .'-]*?)\s+([A-Z]{2})\s*$/);
    if (spaceMatch) {
      return { city: spaceMatch[1].trim(), state: spaceMatch[2] };
    }

    spaceMatch = nameTail.match(/\b([A-Za-z][A-Za-z']*)\s+([A-Z]{2})\s*$/);
    if (spaceMatch) {
      return { city: spaceMatch[1].trim(), state: spaceMatch[2] };
    }

    return { city: '', state: '' };
  }

  function formatStoreAddress(store) {
    if (!store) return '';
    var street = String(store.address || '').trim();
    var city = titleCaseWords(root.dataset.storeCity || '');
    var state = titleCaseWords(root.dataset.storeState || '');

    if (city) {
      var cityRe = new RegExp('^' + city.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s+(?=\\d)', 'i');
      street = street.replace(cityRe, '').trim() || street;
    } else {
      street = street.replace(/^([A-Za-z .'-]+)\s+(?=\d)/, '').trim() || street;
    }

    if (!city || !state) {
      var parsed = cityStateFromName(store.name);
      city = city || parsed.city;
      state = state || parsed.state;
    }

    var parts = [street];
    if (city && state) {
      parts.push(city + ', ' + state);
    } else if (city) {
      parts.push(city);
    }
    return parts.filter(Boolean).join(', ');
  }

  function splitFullName(fullName) {
    var parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return { firstName: '', lastName: '' };
    if (parts.length === 1) return { firstName: parts[0], lastName: '' };
    return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
  }

  function updateInterestStoreNames(name) {
    interestStoreNameEls.forEach(function (el) {
      el.textContent = name;
    });
    if (confirmStoreName) confirmStoreName.textContent = name;
  }

  function updateConfirmModalContent() {
    var store = (window.storesData || {})[window.currentStoreTag];
    if (confirmPhoneRow) confirmPhoneRow.hidden = true;
    if (confirmContactAddress) confirmContactAddress.hidden = true;
    if (confirmMap) confirmMap.hidden = true;
    if (confirmDirections) confirmDirections.hidden = true;
    if (confirmHoursBadge) confirmHoursBadge.hidden = true;
    if (!store) return;
    var name = store.brand || store.name || 'Store';

    updateInterestStoreNames(name);

    if (confirmHoursBadge) {
      var hoursLabel = getStoreHoursLabel(store);
      if (hoursLabel) {
        confirmHoursBadge.textContent = hoursLabel;
        confirmHoursBadge.hidden = false;
      }
    }

    if (confirmContactPhone && confirmContactPhoneText && store.phone) {
      var telHref = 'tel:' + store.phone.replace(/\D/g, '');
      confirmContactPhoneText.textContent = store.phone;
      confirmContactPhone.href = telHref;
      if (confirmCallBtn) confirmCallBtn.href = telHref;
      if (confirmPhoneRow) confirmPhoneRow.hidden = false;
    }

    var fullAddress = formatStoreAddress(store);
    if (confirmContactAddress && confirmContactAddressText && fullAddress) {
      confirmContactAddressText.textContent = fullAddress;
      confirmContactAddress.hidden = false;
    }

    if (confirmDirections && fullAddress) {
      confirmDirections.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(fullAddress);
      confirmDirections.hidden = false;
    }

    if (confirmMap && confirmMapIframe && store.map_embed_url) {
      confirmMapIframe.src = store.map_embed_url;
      confirmMap.hidden = false;
    } else if (confirmMap) {
      confirmMap.hidden = true;
      if (confirmMapIframe) confirmMapIframe.removeAttribute('src');
    }
  }

  function updateStoreLabels() {
    var store = (window.storesData || {})[window.currentStoreTag];
    if (!store) return;
    var name = store.brand || store.name || 'Store';
    var text = name + ' · text or call back';
    if (storeLabel) storeLabel.textContent = text;
    if (storeNameEl) storeNameEl.textContent = name;
    updateInterestStoreNames(name);

    var fullAddress = formatStoreAddress(store);
    if (storeAddressEl) storeAddressEl.textContent = fullAddress;
    if (storeHoursEl) {
      var today = new Date().toLocaleDateString('en-US', { weekday: 'long' });
      var hoursToday = store.hours && store.hours[today] ? store.hours[today] : 'See store hours';
      if (hoursToday === 'Closed' || hoursToday === 'Closed today') {
        storeHoursEl.textContent = '● Closed today';
      } else {
        var closingParts = hoursToday.split(/[–-]/);
        var closingTime =
          closingParts.length > 1 ? closingParts[closingParts.length - 1].trim() : hoursToday;
        storeHoursEl.textContent = '● Open until ' + closingTime;
      }
    }
    if (storePhoneEl && store.phone) {
      storePhoneEl.textContent = store.phone;
      storePhoneEl.hidden = false;
    }
    if (storeDirectionsEl && fullAddress) {
      storeDirectionsEl.href =
        'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(fullAddress);
      storeDirectionsEl.hidden = false;
    }

    if (storeMapIframe && store.map_embed_url) {
      if (storeMapIframe.src !== store.map_embed_url) {
        storeMapIframe.src = store.map_embed_url;
      }
      if (storeMapEl) storeMapEl.hidden = false;
    } else if (storeMapEl) {
      storeMapEl.hidden = true;
      if (storeMapIframe) storeMapIframe.removeAttribute('src');
    }

    updateConfirmModalContent();
  }

  function initDescriptionTabs() {
    var tabs = root.querySelectorAll('[data-ez-pdp-desc-tab]');
    var panels = root.querySelectorAll('[data-ez-pdp-desc-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-ez-pdp-desc-tab');

        tabs.forEach(function (item) {
          var isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-ez-pdp-desc-panel') === target;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  function openModal() {
    if (!modal) return;
    validateForm();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (nameInput) nameInput.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!confirmModal || !confirmModal.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
  }

  function openConfirmModal() {
    if (!confirmModal) return;
    updateConfirmModalContent();
    confirmModal.classList.add('is-open');
    confirmModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (confirmDoneBtn) confirmDoneBtn.focus();
  }

  function closeConfirmModal() {
    if (!confirmModal) return;
    confirmModal.classList.remove('is-open');
    confirmModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (confirmMapIframe) confirmMapIframe.removeAttribute('src');
    if (confirmMap) confirmMap.hidden = true;
  }

  function getExponea() {
    return window.exponea;
  }

  function formatPhoneE164(digits) {
    if (!digits) return '';
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return '+' + digits;
  }

  function getInterestFormValues() {
    var emailInput = form && form.querySelector('#ez-pdp-email');
    var fullName = nameInput ? nameInput.value.trim() : '';
    var nameParts = splitFullName(fullName);
    var email = emailInput ? emailInput.value.trim() : '';
    var phoneDigits = mobileInput ? mobileInput.value.replace(/\D/g, '') : '';
    var note = noteInput ? noteInput.value.trim() : '';
    var hasConsent = consentCheckbox ? consentCheckbox.checked : false;
    var hasEmail = email.length > 0;
    var hasPhone = phoneDigits.length >= 10;
    return {
      fullName: fullName,
      firstName: nameParts.firstName,
      lastName: nameParts.lastName,
      email: email,
      phone: mobileInput ? mobileInput.value.trim() : '',
      phoneE164: formatPhoneE164(phoneDigits),
      note: note,
      hasConsent: hasConsent,
      hasEmail: hasEmail,
      hasPhone: hasPhone,
      emailMarketing: hasEmail && hasConsent,
      smsMarketing: hasPhone && hasConsent,
    };
  }

  function trackConsentEvent(exponea, action, category, values) {
    var props = {
      action: action,
      category: category,
      valid_until: 'unlimited',
      timestamp: new Date().toISOString(),
      source: 'store_inquiry_form',
    };
    if (values.email) props.email = values.email;
    if (values.phoneE164 && category.indexOf('sms') === 0) props.phone = values.phoneE164;
    exponea.track('consent', props);
  }

  function trackInterestExponea() {
    var exponea = getExponea();
    if (!exponea || typeof exponea.track !== 'function') return;

    var values = getInterestFormValues();
    var displayedStore = getDisplayedStoreInfo() || {};

    if (typeof exponea.identify === 'function' && (values.email || values.phoneE164)) {
      var ids = {};
      if (values.email) ids.email_id = values.email;
      if (values.phoneE164) ids.phone_id = values.phoneE164;
      exponea.identify(ids);
    }

    if (typeof exponea.update === 'function') {
      var updatePayload = {
        first_name: values.firstName,
        last_name: values.lastName,
      };
      if (values.email) updatePayload.email = values.email;
      if (values.phoneE164) updatePayload.phone = values.phoneE164;
      exponea.update(updatePayload);
    }

    exponea.track('store_inquiry', {
      product_id: root.dataset.productId || '',
      product_title: root.dataset.productTitle || '',
      product_handle: root.dataset.productHandle || '',
      variant_id: root.dataset.variantId || '',
      product_url: window.location.href,
      first_name: values.firstName,
      last_name: values.lastName,
      full_name: values.fullName,
      email: values.email,
      phone: values.phone,
      note: values.note,
      consent_given: values.hasConsent,
      email_marketing: values.emailMarketing,
      sms_marketing: values.smsMarketing,
      store_name: displayedStore.store_name || '',
      store_phone: displayedStore.store_phone || '',
      store_address: displayedStore.store_address || '',
      store_hours: displayedStore.store_hours || '',
      store_distance: displayedStore.store_distance || '',
      consent_timestamp: values.hasConsent ? new Date().toISOString() : null,
      timestamp: new Date().toISOString()
    });

    trackConsentEvent(
      exponea,
      values.emailMarketing ? 'accept' : 'reject',
      'email-marketing',
      values
    );
    trackConsentEvent(exponea, values.smsMarketing ? 'accept' : 'reject', 'sms-ezplus', values);
  }

  function validateForm() {
    if (!submitBtn || !nameInput || !mobileInput) return;
    var nameOk = nameInput.value.trim().length > 0;
    var digits = mobileInput.value.replace(/\D/g, '');
    var mobileOk = digits.length >= 10;
    var consentOk = consentCheckbox ? consentCheckbox.checked : false;
    submitBtn.disabled = !(nameOk && mobileOk && consentOk);
  }

  function getDisplayedStoreInfo() {
    var card = root.querySelector('[data-ez-pdp-store-card]');
    if (!card) return null;

    function text(el) {
      return el && !el.hidden ? el.textContent.trim() : '';
    }

    var info = {
      store_name: (card.querySelector('[data-ez-pdp-store-name]') || {}).textContent || '',
      store_address: (card.querySelector('[data-ez-pdp-store-address]') || {}).textContent || '',
      store_phone: text(card.querySelector('[data-ez-pdp-store-phone]')),
      store_hours: (card.querySelector('[data-ez-pdp-store-hours]') || {}).textContent || '',
      store_distance: text(card.querySelector('[data-ez-pdp-store-distance]')),
    };
    info.store_name = info.store_name.trim();
    info.store_address = info.store_address.trim();
    info.store_hours = info.store_hours.trim();

    if (!info.store_name && !info.store_address && !info.store_phone) return null;
    return info;
  }

  function buildContactBody() {
    var values = getInterestFormValues();
    var lines = [
      'Product interest request',
      'Product: ' + (root.dataset.productTitle || ''),
      'URL: ' + window.location.href,
      'Variant ID: ' + (root.dataset.variantId || ''),
      'Name: ' + values.fullName,
    ];
    if (values.email) lines.push('Email: ' + values.email);
    if (values.phone) lines.push('Phone: ' + values.phone);
    if (values.note) lines.push('Note: ' + values.note);
    lines.push('Consent given: ' + (values.hasConsent ? 'Yes' : 'No'));
    lines.push('Email marketing: ' + (values.emailMarketing ? 'Yes' : 'No'));
    lines.push('SMS marketing: ' + (values.smsMarketing ? 'Yes' : 'No'));
    var displayedStore = getDisplayedStoreInfo();
    if (displayedStore) {
      if (displayedStore.store_name) lines.push('Store: ' + displayedStore.store_name);
      if (displayedStore.store_phone) lines.push('Store phone: ' + displayedStore.store_phone);
      if (displayedStore.store_address) lines.push('Store address: ' + displayedStore.store_address);
      if (displayedStore.store_hours) lines.push('Store hours: ' + displayedStore.store_hours);
      if (displayedStore.store_distance) lines.push('Store distance: ' + displayedStore.store_distance);
    }
    return lines.join('\n');
  }

  function syncContactNameField() {
    if (!contactNameField || !nameInput) return;
    contactNameField.value = nameInput.value.trim();
  }

  function bodyOverflows(body) {
    if (!body) return false;
    var wasExpanded = body.classList.contains('is-expanded');
    body.classList.remove('is-expanded');
    var overflows = body.scrollHeight > body.clientHeight + 1;
    if (wasExpanded) body.classList.add('is-expanded');
    return overflows;
  }

  function updateReadMoreVisibility(wrap) {
    var body = wrap.querySelector('[data-ez-pdp-read-more-body]');
    var btn = wrap.querySelector('[data-ez-pdp-read-more]');
    if (!body || !btn) return;

    var expanded = btn.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      btn.hidden = false;
      return;
    }

    btn.hidden = !bodyOverflows(body);
  }

  function initReadMoreLinks() {
    var wraps = root.querySelectorAll('[data-ez-pdp-read-more-wrap]');

    function refreshAll() {
      wraps.forEach(updateReadMoreVisibility);
    }

    wraps.forEach(function (wrap) {
      var body = wrap.querySelector('[data-ez-pdp-read-more-body]');
      var btn = wrap.querySelector('[data-ez-pdp-read-more]');
      if (!body || !btn) return;

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var nextExpanded = !expanded;

        btn.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        body.classList.toggle('is-expanded', nextExpanded);
        btn.textContent = nextExpanded ? 'Read less' : 'Read more';
        btn.hidden = false;
      });
    });

    refreshAll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refreshAll, 150);
    });
  }

  function initGallery() {
    if (!galleryTrack) return;
    var slides = galleryTrack.querySelectorAll('[data-ez-pdp-gallery-slide]');
    var total = slides.length;
    if (total <= 1) return;

    if (galleryDots) {
      galleryDots.innerHTML = '';
      for (var d = 0; d < total; d++) {
        var dot = document.createElement('span');
        dot.className = 'ez-pdp-catalog__gallery-dot' + (d === 0 ? ' is-active' : '');
        galleryDots.appendChild(dot);
      }
    }

    function setActive(index) {
      if (galleryCounter) galleryCounter.textContent = index + 1 + ' / ' + total;
      if (galleryDots) {
        var dots = galleryDots.querySelectorAll('.ez-pdp-catalog__gallery-dot');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }
      thumbButtons.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
      });
    }

    function scrollToIndex(index) {
      var w = galleryTrack.offsetWidth;
      if (!w) return;
      galleryTrack.scrollTo({ left: index * w, behavior: 'smooth' });
      setActive(index);
    }

    galleryTrack.addEventListener(
      'scroll',
      function () {
        var w = galleryTrack.offsetWidth;
        if (!w) return;
        setActive(Math.round(galleryTrack.scrollLeft / w));
      },
      { passive: true }
    );

    thumbButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        scrollToIndex(parseInt(btn.getAttribute('data-ez-pdp-thumb') || '0', 10));
      });
    });
  }

  /* Drift hover zoom — desktop / fine pointer only (parity with Warehouse ProductGallery._createZoom) */
  function initImageZoom() {
    if (root.dataset.enableImageZoom !== 'true') return;
    if (typeof Drift === 'undefined') return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var zoomWrapper = root.querySelector('.ez-pdp-catalog__zoom-wrapper');
    var zoomEffect = root.dataset.zoomEffect || 'outside';
    var images = root.querySelectorAll('.ez-pdp-catalog__gallery-img[data-zoom]');
    if (!images.length) return;

    var inlineBelowLap = window.innerWidth < 1024;
    images.forEach(function (image) {
      new Drift(image, {
        containInline: zoomEffect === 'outside',
        inlinePane: inlineBelowLap ? true : zoomEffect !== 'outside',
        hoverBoundingBox: zoomEffect === 'outside',
        handleTouch: false,
        inlineOffsetY: inlineBelowLap ? -85 : 0,
        paneContainer: zoomWrapper,
      });
    });
  }

  /* Online exclusive add-to-cart — temporarily disabled.
  function updateAddToCartAvailability() {
    if (!variantSelect || !addToCartButtons.length) return;
    var option = variantSelect.options[variantSelect.selectedIndex];
    var available = option && !option.disabled;
    addToCartButtons.forEach(function (btn) {
      btn.disabled = !available;
      btn.classList.toggle('ez-pdp-catalog__btn-primary--disabled', !available);
    });
    if (root.dataset.variantId && option) {
      root.dataset.variantId = option.value;
    }
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', updateAddToCartAvailability);
    updateAddToCartAvailability();
  }
  */

  interestButtons.forEach(function (btn) {
    btn.addEventListener('click', openModal);
  });
  if (storeMapEl && storeDirectionsEl) {
    storeMapEl.addEventListener('click', function () {
      if (storeDirectionsEl.hidden) return;
      var href = storeDirectionsEl.getAttribute('href');
      if (!href || href === '#') return;
      storeDirectionsEl.click();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  
  if (confirmCloseBtn) confirmCloseBtn.addEventListener('click', closeConfirmModal);
  if (confirmDoneBtn) confirmDoneBtn.addEventListener('click', closeConfirmModal);
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
  }
  if (confirmModal) {
    confirmModal.addEventListener('click', function (e) {
      if (e.target === confirmModal) closeConfirmModal();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (confirmModal && confirmModal.classList.contains('is-open')) {
      closeConfirmModal();
      return;
    }
    if (modal && modal.classList.contains('is-open')) closeModal();
  });

  wishlistButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var swym = getSwymButton();
      if (swym) swym.click();
      setTimeout(syncWishlistPressed, 400);
    });
  });

  if (form) {
    form.addEventListener('input', validateForm);
    form.addEventListener('change', validateForm);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      syncContactNameField();
      if (bodyField) bodyField.value = buildContactBody();
      validateForm();
      if (submitBtn && submitBtn.disabled) return;

      trackInterestExponea();

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
      var formData = new FormData(form);
      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      })
        .then(function () {
          form.reset();
          if (consentCheckbox) consentCheckbox.checked = true;
          submitBtn.textContent = 'Submit';
          submitBtn.disabled = true;
          closeModal();
          openConfirmModal();
        })
        .catch(function () {
          submitBtn.textContent = 'Submit';
          submitBtn.disabled = false;
          alert('Something went wrong. Please try again.');
        });
    });
    validateForm();
  }

  if (initialStore) {
    var text = initialStore + ' · text or call back';
    if (storeLabel) storeLabel.textContent = text;
    updateInterestStoreNames(initialStore);
  }

  document.addEventListener('storesDataReady', function () {
    updateStoreLabels();
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (window.storesData) updateStoreLabels();
  });
  if (window.storesData) updateStoreLabels();

  function initPickupTabletPlacement() {
    var block = root.querySelector('[data-ez-pdp-pickup-block]');
    var home = root.querySelector('[data-ez-pdp-pickup-home]');
    var gallery = root.querySelector('.ez-pdp-catalog__gallery');
    if (!block || !home || !gallery) return;

    var mq = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');

    function place() {
      if (mq.matches) {
        if (block.previousElementSibling !== gallery) {
          gallery.insertAdjacentElement('afterend', block);
        }
      } else if (block.parentElement !== home) {
        home.appendChild(block);
      }
    }

    place();
    if (mq.addEventListener) mq.addEventListener('change', place);
    else if (mq.addListener) mq.addListener(place);
  }

  initReadMoreLinks();
  initGallery();
  initImageZoom();
  initDescriptionTabs();
  initPickupTabletPlacement();
  syncWishlistPressed();

  var swymObserve = getSwymButton();
  if (swymObserve && typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(syncWishlistPressed);
    mo.observe(swymObserve, { attributes: true, attributeFilter: ['class', 'aria-pressed'] });
  }

  setInterval(syncWishlistPressed, 2000);
})();
